<template>
  <div class="invite-template">
    <template v-if="!isPaidSubscription">
      <p class="info-text">
        Increase review invite conversions by sending SMS invites in addition to email invites. Simply include your customer’s mobile number to send an SMS invite.
      </p>
    </template>
    <div class="columns is-flex-tablet data-box" :class="[ !isPaidSubscription ? 'locked-section' : '' ]">
      <div class="left-section column is-7-widescreen is-7-desktop is-7-tablet is-full-mobile" >
        <div class="field">
          <label class="label is-size-7">Message</label>
          <div class="control">
            <textarea
              :class="[{'disable-field': !userInfo}, 'textarea']"
              placeholder="Textarea"
              v-model="body"
              ref="body"
              :readonly="!isPaidSubscription"
              :disabled="!isPaidSubscription"
              @keyup="handleFieldChange"
              @click="currentCursor = 'body'" :maxlength="max"
            ></textarea>
            <p class="limit-160-characters" v-if="isPaidSubscription">Limit: 160 characters. Remaining <span class="input-group-addon" v-text="(max - body.length)"></span></p>
          </div>
        </div>
        <div class="field" v-if="isPaidSubscription">
          <label class="label is-size-7">Tags</label>
          <div class="control">
            <ul class="tags">
              <li v-for="tag of tags" v-bind:key="tag" class="tag" :class="[{'add-tag': isPaidSubscription}]" @click="handleTag(tag)">{{tag}}</li>
            </ul>
          </div>
        </div>

        <div class="locked" v-if="!isPaidSubscription">
          <div class="locked-header">
            <p>
              <label>SMS Template Customisation</label>
              <img src="/static/img/free-lock-icon.png" width="15" height="15" alt="Free Subscription" class="lock-icon">
            </p>
          </div>
          <div class="locked-body">
            <p><a href="#" @click.prevent="renewOrUpgrade"><u>Upgrade</u></a> your package to customise your SMS review invites.</p>
          </div>
        </div>

        <div class="field" v-if="isPaidSubscription">
          <div>
            <ul class="action-buttons">
              <li>
                <button
                  :disabled="!isFormChanged"
                  @click="saveContent"
                  :class="[{ 'is-loading': isSaving }, 'button is-button-blue is-uppercase']"
                >
                  SAVE
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    /* eslint-disable indent,no-new,no-undef,valid-jsdoc */
    import axios from 'axios'

    export default {
        name: 'ReviewInviteSMSSetup',
        data () {
            return {
                tags: [],
                body: '',
                subject: '',
                userInfo: JSON.parse(localStorage.getItem('billingDetails')),
                isActive: false,
                isSaving: false,
                isPreviewing: false,
                leavingPage: false,
                isFormChanged: false,
                htmlPreview: '',
                iframeWidth: '100%',
                currentCursor: 'body',
                businessSlug: localStorage.getItem('org_slug'),
                businessID: localStorage.getItem('org_id'),
                max: 160
            }
        },
        metaInfo: {
            title: 'Business Portal | Hellopeter - Review Invites SMS Setup'
        },
        created () {
            if (this.leavingPage === true || this.isFormChanged === false) {
                this.leavingPage = false
            }
            // Event bus for modal's response
            window.events.$on('navigateTowardsRoute', this.handleNavigation)
            this.isPreviewing = true
            // Getting the template content for preview
            this.updateBusinessType()
            .then((response) => {
                this.userInfo.subscription.name = response.subscription.name
                this.getReviewInvitationTemplate()
            })
        },
        computed: {
            /**
             * Check the user type whether it is of Enterprise/Pro
             * @return {boolean}
             */
            userType () {
                // If user having Enterprise/Pro business
                return true
            },
            /**
             * Check the user type whether it is having Paid plan
             * @return {boolean}
             */
            isPaidSubscription () {
              // If user having Other than Free business
              return this.userInfo.subscription.name !== 'Free'
            }
        },
        methods: {
            /**
             * Update business in local storage, in case of business switch
             * @return {Promise}
             */
            updateBusinessType () {
                return new Promise((resolve) => {
                    axios.get(`/${this.businessSlug}/billing-details`)
                        .then(({data}) => {
                            localStorage.setItem('billingDetails', JSON.stringify(data))
                            resolve(data)
                        })
                })
            },
            /**
             * Get the invitation template content for preview
             * @return {void}
             */
            getReviewInvitationTemplate (mode = 'get') {
              let data = {
                type: 'SMS'
              }

              if (mode === 'get') {
                data = Object.assign(data, {body: '', subject: '', mode: 'get'})
              } else if (mode === 'selected') {
                data = Object.assign(data, {body: '', subject: '', mode: 'selected'})
              } else {
                data = Object.assign(data, {body: this.body, subject: this.subject, mode: 'preview'})
              }

              axios.post(`/${this.businessSlug}/review/get-review-invite-sms-template`, data)
                    .then((response) => {
                        this.body = response.data.body
                        this.htmlPreview = response.data.view
                        this.subject = response.data.subject
                        this.tags = response.data.tags
                        this.isPreviewing = false
                    })
                    .catch(() => {
                        flash('You are not authorized to view this resource.', 'is-danger')
                    })
            },
            /**
             * Toggle between Desktop and mobile preview
             * @return {void}
             */
            responsive (type) {
                this.isActive = !this.isActive
                this.iframeWidth = type === 'desktop' ? '100%' : '320'
            },
            /**
             * When user change any text in fields
             * @return {void}
             */
            handleFieldChange () {
                this.isFormChanged = true
            },
            /**
             * Handling redirection when user want to leave the page
             * @param routeTowards Route towards request is navigating
             * @return {void}
             */
            handleNavigation (routeTowards) {
                this.leavingPage = true
                if (this.isFormChanged) {
                    this.$router.push(routeTowards)
                    this.isFormChanged = false
                }
            },
            /**
             * Save the subject/body to DB
             * @return {void}
             */
            saveContent () {
                this.isSaving = true
                axios.post(`/${this.businessSlug}/review/invite-template`, {
                    body: this.body,
                    subject: this.subject,
                    type: 'sms'
                })
                    .then((response) => {
                        flash(response.data.message, 'is-success')
                        this.isSaving = this.isFormChanged = false
                        this.getReviewInvitationTemplate()
                    })
                    .catch((error) => {
                        this.isSaving = this.isFormChanged = false
                        flash(error.response.data.message, 'is-danger')
                    })
            },
            /**
             * Replace the selected tag with selected string or at end of textarea string
             * @param {string} tag Selected tag
             * @return {void}
             */
            handleTag (tag) {
                // If user is Enterprise/Pro business user
                if (this.userType && this.isPaidSubscription) {
                    this.handleFieldChange()
                    // Getting the reference where to append tag [subject|body]
                    let tArea = this.$refs[this.currentCursor]
                    let startPos = tArea.selectionStart
                    let endPos = tArea.selectionEnd
                    let tmpStr = tArea.value
                    // insert the chosen tag to selected text or at very end of the textarea string
                    this[this.currentCursor] = tmpStr.substring(0, startPos) + ` ${tag} ` + tmpStr.substring(endPos, tmpStr.length)
                }
            },
            /**
             *  Redirect to renew or upgrade page
             *  @returns {void}
             */
            renewOrUpgrade () {
              this.$router.push('/billing/edit-plan/g1/monthly')
            }
        },
        /**
         * Event before navigating to desired route
         * @param {object} to Route where user want to navigate
         * @param {object} from Route where is coming from navigation
         * @param {function} next Navigating towards the intended route if true
         * @return {void}
         */
        beforeRouteLeave (to, from, next) {
            // If user changed the form and is Enterprise/Pro user
            if (this.isFormChanged && !this.leavingPage && this.isPaidSubscription) {
                this.modal_props = {
                    title: 'Are you sure?',
                    body: 'You have unsaved changes on this page. If you navigate away, your changes will be lost. ',
                    btn_action_title: 'STAY ON THIS PAGE',
                    secondary_btn_title: 'LEAVE PAGE',
                    to_path: to.path,
                    show_btns: true,
                    task: 'deleteInvite'
                }
                // Fire off confirmation modal
                modal(this.modal_props)
            } else {
                next()
            }
        }
    }
</script>
<style scoped>
  .invite-template {
    margin-top: 18px;
  }
  .invite-template .info-text {
    font-size: 12px;
    color: #707070;
    margin: 5px 0;
  }
  .left-section{
    padding-left: 0;
  }
  .add-tag {
    cursor: pointer;
  }
  .tags li {
    width: 39px;
    height: 21px;
    font-size: 12px;
    line-height: 1.42;
    color: #707070 !important;
    background: rgba(138, 140, 145, 0.1) !important;
  }

  .tags li:nth-child(2) {
    width: 101px;
    height: 21px;
  }
  .disable-field{
    pointer-events: none;
  }

  iframe {
    border: 1px solid #CCCCCC;
    max-width: 100%;
    margin: 0px auto;
    display: block;
  }
  .responsive-action{
    text-align: center;
    margin-bottom: 10px;
  }
  .responsive-action span{
    cursor: pointer;
  }
  .has-margin-top-1{
    margin-top: 10px;
  }
  .noselect {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently supported by Chrome, Opera and Firefox */
  }
  .preview-loader{
    max-width: 20% !important;
  }
  .textarea {
    width: 515px;
    min-width:300px;
    min-height:100px !important;
    height: 101px;
    opacity: 1;
    border: solid 1px #dbdbdb;
    background-color: #ffffff;
    font-size: 12px;
    color: #707070;
    resize: none;
    outline: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
     box-shadow: none;
  }
  .left-section{
    width: 515px !important;
  }
</style>
<style scoped>
  .preview-button-color, .preview-button-color:hover{
    color: #dbdbdb !important;
    border-color: #dbdbdb !important;
  }
  .action-buttons{
    padding: 5px 0;
  }
  .action-buttons li{
    display: inline;
    width: 150px;
  }
  .button{
    height: 35px;
    width: 150px;
  }
  .disable-field{
    color: #8a8c91 !important;
  }
  .input{
    color: #4a4a4a;
  }
  .fas.fa-lock {
    margin-right: 5px;
  }
  .limit-160-characters {
    width: 166px;
    height: 14px;
    opacity: 0.6;
    font-family: OpenSans;
    font-size: 10px;
    color: #58595b;
    margin-left: 359px;
    margin-top: -19px;
  }
  .limit-160-characters span{
    font-size: 10px !important;
    font-family: OpenSans;
  }
  .label{
    width: 55px;
    height: 17px;
    font-size: 12px;
    font-weight: bold;
    line-height: 1.67;
    color: #58595b;
  }
  .locked{
    width: 515px;
    height: 112px;
    margin: 20px 0 0 0;
    border: solid 1px #dbdbdb;
  }
  .locked .locked-header{
    height: 64px;
  }
  .locked .locked-header p{
    font-size: 12px;
    font-weight: bold;
    height:37px;
    border-block-end: solid 1px #dbdbdb;
    padding-top: 10px;
    padding-left: 11px;
    padding-right: 14.5px;
  }
  .locked .locked-header p label{
    width: 59px;
    height: 19px;
    color: #58595b;
  }
  .locked .locked-header p img{
    float:right;
  }
  .locked .locked-body{
    width: 100%;
    color: #707070;
  }
  .locked .locked-body p{
    width: 100%;
    height: 34px;
    font-size: 12px;
    text-align: center;
  }
  .locked-section{
    background: rgba(255, 255, 255, 0.8);
  }
  .locked-section label{
    color: #58595b;
    /*opacity: .5;*/
  }
  .locked-section .tags, .locked-section .limit-160-characters{
    opacity: 0.5;
  }
  .button{
    width: 150px;
    height: 35px;
    font-size: 12px;
    text-align: center;
    color: #ffffff;
    border-radius:2px;
  }
  .locked-section .button{
    background: #30aae1 !important;
  }
  .locked-body p a u{
    color: #30aae1;
  }
  .data-box{
    width: 515px;
  }
  .locked{
    width: 515px;
  }
  .field{
    width:545px;
  }
.invite-template{
  min-width:400px;
}
</style>



// WEBPACK FOOTER //
// src/pages/collect-reviews/ReviewInviteSMSSetup.vue